const casinos = [
  {
    id: 1,
    name: '888 Casino',
    logo: '/logos/888casino.png',
    rating: 4.9,
    description: 'Award-winning casino with 30+ years of excellence. Enjoy a massive game library, generous welcome bonus, and top-tier customer support around the clock.',
    bonus: '100% up to £100 + 50 Free Spins',
    badges: ['Editor\'s Choice', 'Fast Payouts', 'Live Casino', 'VIP Programme'],
    url: 'https://www.888casino.com/',
    featured: true
  },
  {
    id: 2,
    name: 'Jackpotjoy',
    logo: '/logos/jackpotjoy.png',
    rating: 4.8,
    description: 'Home of jackpots and bingo excellence. Jackpotjoy delivers a fun-filled experience with exclusive games, daily promotions, and a vibrant community.',
    bonus: '30 Free Spins + Up to £50 Bingo Bonus',
    badges: ['Top Rated', 'Bingo Games', 'Jackpot Slots', 'Daily Rewards'],
    url: 'https://www.jackpotjoy.com/',
    featured: true
  },
  {
    id: 3,
    name: '32Red',
    logo: '/logos/32Red.png',
    rating: 4.7,
    description: 'Multiple award-winning online casino trusted by millions. Premium gaming experience with over 500 games, excellent mobile app, and rewarding loyalty scheme.',
    bonus: '150% Welcome Bonus up to £150',
    badges: ['Award Winner', '500+ Games', 'Mobile App', 'Trusted Brand'],
    url: 'https://www.32red.com/'
  },
  {
    id: 4,
    name: 'Casumo',
    logo: '/logos/Casumo.png',
    rating: 4.6,
    description: 'Adventure-themed casino with a unique gamification experience. Earn rewards as you play, unlock achievements, and enjoy a fresh approach to online gaming.',
    bonus: '100% up to £25 + 20 Free Spins',
    badges: ['Gamification', 'Quick Withdrawals', 'Unique Experience', 'Mobile First'],
    url: 'https://www.casumo.com/'
  },
  {
    id: 5,
    name: 'Mr Green',
    logo: '/logos/mrgreen.png',
    rating: 4.7,
    description: 'Award-winning casino known for responsible gaming tools and premium experience. Curated game selection, predictive player protection, and elegant interface.',
    bonus: '100 Free Spins on First Deposit',
    badges: ['Green Gaming', 'Award Winner', 'Premium Quality', 'Safe Play'],
    url: 'https://www.mrgreen.co.uk/'
  },
  {
    id: 6,
    name: 'BetVictor',
    logo: '/logos/betvictor.png',
    rating: 4.5,
    description: 'Established bookmaker with a fantastic casino section. Over 60 years in the business, BetVictor offers reliability, great odds, and an extensive games portfolio.',
    bonus: 'Bet £5 Get £30 in Bonuses',
    badges: ['Est. 1946', 'Sports & Casino', 'Live Dealers', 'Trusted'],
    url: 'https://www.betvictor.com/'
  },
  {
    id: 7,
    name: 'Kwiff',
    logo: '/logos/kwiff.png',
    rating: 4.4,
    description: 'The supercharged betting app that randomly boosts your odds. Experience the thrill of surprise wins with their unique kwiff technology and modern platform.',
    bonus: 'Get Supercharged Odds Daily',
    badges: ['Odds Boost', 'Modern App', 'Quick Bets', 'Innovative'],
    url: 'https://www.kwiff.com/'
  },
  {
    id: 8,
    name: 'MrQ',
    logo: '/logos/mrq.png',
    rating: 4.5,
    description: 'No wagering requirements, ever. MrQ keeps it simple with instant withdrawals, no caps on winnings, and a straightforward approach to online slots and bingo.',
    bonus: '10 Free Spins No Wagering',
    badges: ['No Wagering', 'Instant Cashout', 'Simple & Fair', 'Slots & Bingo'],
    url: 'https://www.mrq.com/'
  },
  {
    id: 9,
    name: 'Sky Vegas',
    logo: '/logos/skyvegas.png',
    rating: 4.6,
    description: 'Part of the trusted Sky family with exclusive games and massive jackpots. Premium gaming destination with hundreds of slots and exceptional live casino tables.',
    bonus: '50 Free Spins No Wagering',
    badges: ['Sky Brand', 'Exclusive Games', 'No Wagering', 'Huge Jackpots'],
    url: 'https://www.skyvegas.com/'
  }
];

export default casinos;
